import React from "react";
import {
  Card,
  Button,
  Space,
  Typography,
  Avatar,
  Row,
  Col,
  Divider,
} from "antd";
import {
  EditOutlined,
  GlobalOutlined,
  BankOutlined,
  LinkedinOutlined,
  SolutionOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

const ProfExperienceView = ({ userData, onEdit }) => {

  // 1. Calculate the valid organisations list once (Do this outside the return statement or within a useEffect/memo)
  const validOrganisations = userData.organisations?.filter(item => item?.organisation || item?.role);

  // 2. Determine if the section should be visible
  const hasOrganisations = validOrganisations && validOrganisations.length > 0;
  return (
    <div>
      {/* <div style={{ textAlign: "center", marginBottom: "24px" }}>
        <Button
          type="default"
          icon={<EditOutlined />}
          onClick={onEdit}
          style={{
            position: "absolute",
            top: "24px",
            right: "24px",
            borderColor: "#fa541c",
            color: "#fa541c",
          }}
        ></Button>
      </div> */}
      {userData.about && (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Title level={3}>Biography</Title>

          <Row align="middle">
            <Col flex="auto" style={{ paddingLeft: "1px" }}>
              <Text>{userData.about}</Text>
            </Col>
          </Row>
          {userData.linkedIn && (
            <Row align="middle">
              <Col flex="auto" style={{ paddingLeft: "1px" }}>
                <div>
                  <LinkedinOutlined
                    style={{ paddingRight: "5px", fontSize: "18px" }}
                  />
                  <a
                    href={userData.linkedIn}
                    target="_blank"
                    style={{ color: "#b64a31" }}
                  >
                    {userData.linkedIn}
                  </a>
                </div>
              </Col>
            </Row>
          )}
          {userData.website && (
            <Row align="middle">
              <Col flex="auto" style={{ paddingLeft: "1px" }}>
                <GlobalOutlined
                  style={{ paddingRight: "5px", fontSize: "18px" }}
                />
                <a
                  href={userData.website}
                  target="_blank"
                  style={{ color: "#b64a31" }}
                >
                  {userData.website}
                </a>
              </Col>
            </Row>
          )}

          <Divider />
        </Space>
      )}

      <Space direction="vertical" style={{ width: "100%" }}>
        <Title level={3}>Qualification(s)</Title>
        <ul>
          {userData?.qualifications?.map((q, key) => (
            <li align="left" key={key}>
              <Text strong style={{ fontSize: 16 }}>
                {q.qualification.value}
              </Text>
              <br />
              <Text>{q.institution}</Text>
              <br />
              <Text type="secondary">{q.field}</Text>
              <br />
            </li>
          ))}
        </ul>
      </Space>
      <Divider />
      {userData.employmentStatus && (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Title level={3}>Employment Status</Title>
          <Text strong style={{ fontSize: 16 }}>
            {userData.employmentStatus?.value}
          </Text>
          <Divider />
        </Space>
      )}

      {userData.employmentStatus &&
        userData.employmentStatus?.value &&
        ["employed", "self-employed"].includes(
          userData.employmentStatus.value.toLowerCase()
        ) && (
          <Space direction="vertical" style={{ width: "100%" }}>
            <Title level={3}>Occupation</Title>
            <div key={"occupation"} style={{ marginLeft: "10px" }}>
              <Row align="middle">
                <Col className="prof-icon">
                  <Avatar
                    icon={<SolutionOutlined />}
                    style={{
                      color: "#D1715B",
                      backgroundColor: "#fff",
                      border: "2px solid #D1715B",
                      marginRight: 12,
                    }}
                    size={48}
                  />
                </Col>
                <Col flex="auto" className="prof-text">
                  <Text strong style={{ fontSize: 16 }}>
                    {userData.occupation.value}
                  </Text>
                  <br />
                  <Text type="secondary">{userData.specialisation}</Text>
                  <br />
                  <Text>{userData.employment.value}</Text>
                  <br />
                </Col>
              </Row>
            </div>
            <Divider />
          </Space>
        )}

      <Space direction="vertical" style={{ width: "100%" }}>
        {hasOrganisations && (
          <Space direction="vertical" style={{ width: "100%" }}>
            <Title level={3}>Professional Bodies or Volunteer Associations</Title>
            {/* Map over the pre-calculated valid list */}
            {validOrganisations.map((q, key) => (
              <div key={key} style={{ marginLeft: "10px" }}>
                <Row align="middle">
                  <Col className="prof-icon">
                    <Avatar
                      icon={<BankOutlined />}
                      style={{
                        color: "#D1715B",
                        backgroundColor: "#fff",
                        border: "2px solid #D1715B",
                        marginRight: 12,
                      }}
                      size={48}
                    />
                  </Col>
                  <Col flex="auto" className="prof-text">
                    <Text strong style={{ fontSize: 16 }}>
                      {q.organisation}
                    </Text>
                    <br />
                    <Text>{q.role}</Text>
                  </Col>
                </Row>
                <br />
              </div>
            ))}
          </Space>
        )}
      </Space>

      <div style={{ textAlign: "right", marginTop: "30px" }}>
        <Button
          type="primary"
          onClick={onEdit}
          // style={{ backgroundColor: '#fa541c', borderColor: '#fa541c' }}
          className="primary-volunteer-button"
        >
          Edit
        </Button>
      </div>
    </div>
  );
};

export default ProfExperienceView;
